<template>
  <div>
    <table-card v-if="deals.length" :items="deals" :fields="fields">
      <template #cell(edit)="data">
        <b-btn :to="{ name: 'AdminDealSettings', params: { dealid: data.item.id } }">Edit</b-btn>
      </template>

      <template #cell(delete)="data">
        <b-btn :disabled="!isSuperAdmin"
          variant="danger" class="px-3" @dblclick.stop="delDeal(data.item.id)">X</b-btn>
      </template>

      <template #cell(status)="data">
        <div class="w-25 text-nowrap">
          <toggle-button
            class="my-auto mr-4"
            v-model="data.item.enabled"
            :sync="true"
            @change="updateDeal(data.item)"
            color="#2bd879">
          </toggle-button>
        </div>
      </template>

      <template #cell(type)="data">
        <b-badge>
          {{ data.item.type ? data.item.type : 'OPEN' }}
        </b-badge>
      </template>
    </table-card>
    <b-card v-else>
      <h4>No deals created yet</h4>
    </b-card>

    <div class="row text-left">
      <div class="col-sm">
        <b-btn type="button" :to="{ name: 'AdminDealSettings' }" variant="primary" class="my-3 mx-0">
          + New Deal
        </b-btn>
      </div>
    </div>

  </div>
</template>

<script>
  import auth from '@/auth'
  import { DemandApi } from "../api"
  import TableCard from "../../components/TableCard"

  export default {
      name: 'PublicDeals',
      created () {
          let mode = this.mode()
          if(mode === 'admin') {
              DemandApi.dealList().then((list) => {
                  this.deals = list
              })
          }
      },
      data () {
          return {
              isSuperAdmin: auth.isSuperAdmin(),
              fields: [
                { key: 'name', sortable: true },
                { key: 'id', sortable: true },
                { key: 'status', sortable: true },
                { key: 'type', sortable: true },
                { key: 'edit', sortable: false },
                { key: 'DELETE', sortable: false }
              ],
              deals: []
          }
      },
      methods: {
          mode () {
              return this.$route.path.split("/")[1]
          },
          delDeal (id) {
            console.log('Deleting ' + id)

            DemandApi.dealDelete(id).then(() => {
              this.$notify.success('Deal ' + id + 'deleted')

              DemandApi.dealList().then((list) => {
                this.deals = list
              })
            }).catch(e => {
              this.$notify.error('Failed to delete deal')
            })
          },
        updateDeal (deal) {
          DemandApi.dealSave(deal).then(() => {
            this.$notify.success('Deal ' + deal.enabled ? 'enabled' : 'disabled')
          }).catch(e => {
            this.$notify.error('Failed to update deal status')
          })
        }
      },
      computed: {
          isAdmin () {
              return auth.isAdmin()
          }
      },
      components: {
          TableCard
      }
  }
</script>



// WEBPACK FOOTER //
// src/demand/pages/Deals.vue